export const jsonDataforJourneyPlan = 
  {
    _id:"",
    user: {
      id: "62eac8b400a11d9985fb405d",
      name: "Justin Delarosbel",
      email: "justin.delarosbel@ontarionorthland.ca",
    },
    roadMaster: {},
    tasks: [
      {
        taskId: "563c0617-3247-4a92-26ca-f96b7892b642",
        startLocation: "46.41446893,-79.21141833",
        endLocation: "46.41446834,-79.21144528",
        startTime: "Fri Oct 06 23:04:05 EDT 2023",
        endTime: "Fri Oct 06 23:04:19 EDT 2023",
        status: "Finished",
        title: "Temagami Territory 1 Main Track Inspt",
        desc: "Perform Inspection",
        notes: "Default Inspection Notes",
        imgs: "null",
        startLoc: {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [-79.44794297218323, 46.29496459648388],
          },
        },
        endLoc: {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [-79.42784662765382, 46.53831251679169],
          },
        },
        lineCords: {
          type: "",
          id: "f3410e1a-a2cc-3a96-42e1-3a4417b68fdd",
          runId: "621785ae95ccc46dbf2d3f9f",
          geometry: {
            type: "LineString",
            coordinates: [],
          },
        },
        userStartMP: "0",
        userEndMP: "25.1",
        runStart: "0",
        runEnd: "25.1",
        traverseTrack: "631f875a0fb67e3a5139312f",
        observeTrack: "",
        traverseBy: "Hi-Rail",
        weatherConditions: "Light rain",
        temperature: "18",
        inspectionType: "Required Inspection",
        inspectionTypeTag: "required",
        inspectionTypeDescription: "patrolled mainline ",
        tempUnit: "C",
        locUnit: "MP",
        appVersion: "9.2",
        includeInFRAReport: true,
        ativIssues: [],
        issues: [],
        units: [
          {
            track_id: "null",
            id: "6213bd64cb915c1c14002fcc",
            unitId: "Temagami Mainline",
            start: "0",
            end: "138.5",
            assetType: "Lines/Yard",
            coordinates: [
              ["46.29496459648388", "-79.44794297218323"],
              ["46.538312516791684", "-79.42784662765382"],
            ],
            parent_id: "61f027cc6288dd51709356b1",
            attributes: {
              primaryTrack: false,
              trackOrientation: "",
              showDirection: false,
              group: "",
              railOptions: [],
            },
            startMarker: "",
            endMarker: "",
            testForm: [],
            freeze: false,
            parentAsset: {
              assetType: "Subdivision",
              _id: "61f027cc6288dd51709356b1",
              unitId: "Temagami",
            },
            appForms: [],
          },
          {
            track_id: "null",
            id: "6213c3b36bf5782270508b04",
            unitId: "PICHES SPUR",
            start: "0.7",
            end: "0.7",
            assetType: "Spur",
            coordinates: [
              ["46.3036607114866", "-79.4488136007237"],
              ["46.3036607114866", "-79.4488136007237"],
            ],
            parent_id: "6213bd64cb915c1c14002fcc",
            attributes: {
              primaryTrack: false,
              trackOrientation: "",
              showDirection: false,
              group: "",
              railOptions: [],
            },
            startMarker: "",
            endMarker: "",
            testForm: [
              {
                startDate: "2023-07-01T04:00:00.000Z",
                assetType: "Spur",
                testCode: "sidingInspectionForm1",
                assetId: "6213c3b36bf5782270508b04",
                nextDueDate: "2023-10-01T04:00:00.000Z",
                nextExpiryDate: "2023-11-01T03:59:59.000Z",
                testId: "1fa883bf-0bb0-2f67-5236-31b8619c15a5",
                start: 0,
                end: 0,
                lineId: "",
                title: "Monthly Spur Track Inspection",
                timezone: "",
                currentPeriodStart: "2023-10-01T04:00:00.000Z",
                currentPeriodEnd: "2023-11-01T03:59:59.000Z",
                linearProps: {
                  inspectionType: "traversed",
                },
                alertInfo: {
                  expiryAlertDays: "5",
                },
              },
            ],
            freeze: false,
            appForms: [],
            formLists: {
              appFormsList: ["sidingInspectionForm1"],
            },
          },
          {
            track_id: "null",
            id: "6213c3b36bf5782270508b05",
            unitId: "FERONIA SIDING",
            start: "8.8",
            end: "9.56",
            assetType: "Side Track",
            coordinates: [
              ["46.36135541255538", "-79.32483628644022"],
              ["46.368685977632566", "-79.31298326991147"],
            ],
            parent_id: "6213bd64cb915c1c14002fcc",
            attributes: {
              primaryTrack: false,
              trackOrientation: "",
              showDirection: false,
              group: "",
              railOptions: [],
            },
            startMarker: "",
            endMarker: "",
            testForm: [
              {
                startDate: "2023-07-01T04:00:00.000Z",
                assetType: "Side Track",
                testCode: "sidingInspectionForm1",
                assetId: "6213c3b36bf5782270508b05",
                nextDueDate: "2023-10-01T04:00:00.000Z",
                nextExpiryDate: "2023-11-01T03:59:59.000Z",
                testId: "7e2e64fc-6b11-f3d9-6a8e-f297b5995fcf",
                start: 0,
                end: 0,
                lineId: "",
                title: "Monthly Side Track Inspection",
                timezone: "",
                currentPeriodStart: "2023-10-01T04:00:00.000Z",
                currentPeriodEnd: "2023-11-01T03:59:59.000Z",
                linearProps: {
                  inspectionType: "traversed",
                },
                alertInfo: {
                  expiryAlertDays: "5",
                },
              },
            ],
            freeze: false,
            appForms: [],
            formLists: {
              appFormsList: ["sidingInspectionForm1"],
            },
          },
          {
            track_id: "null",
            id: "6213c3b36bf5782270508b06",
            unitId: "MULOCK SPUR",
            start: "18.9",
            end: "18.9",
            assetType: "Spur",
            coordinates: [
              ["46.46247931429218", "-79.38285368119298"],
              ["46.46247931429218", "-79.38285368119298"],
            ],
            parent_id: "6213bd64cb915c1c14002fcc",
            attributes: {
              primaryTrack: false,
              trackOrientation: "",
              showDirection: false,
              group: "",
              railOptions: [],
            },
            startMarker: "",
            endMarker: "",
            testForm: [
              {
                startDate: "2023-07-01T04:00:00.000Z",
                assetType: "Spur",
                testCode: "sidingInspectionForm1",
                assetId: "6213c3b36bf5782270508b06",
                nextDueDate: "2023-10-01T04:00:00.000Z",
                nextExpiryDate: "2023-10-13T03:59:59.000Z",
                testId: "1fa883bf-0bb0-2f67-5236-31b8619c15a5",
                start: 0,
                end: 0,
                lineId: "",
                title: "Monthly Spur Track Inspection",
                timezone: "",
                currentPeriodStart: "2023-10-01T04:00:00.000Z",
                currentPeriodEnd: "2023-11-01T03:59:59.000Z",
                linearProps: {
                  inspectionType: "traversed",
                },
                alertInfo: {
                  expiryAlertDays: "5",
                },
              },
            ],
            freeze: false,
            appForms: [],
            formLists: {
              appFormsList: ["sidingInspectionForm1"],
            },
          },
          {
            track_id: "null",
            id: "6213c3b36bf5782270508b16",
            unitId: "FERONIA BACK TRACK",
            start: "8.9",
            end: "9",
            assetType: "Storage Track 1",
            coordinates: [
              ["46.362378831462124", "-79.32335332345646"],
              ["46.36340223119841", "-79.32187030491347"],
            ],
            parent_id: "6213bd64cb915c1c14002fcc",
            attributes: {
              primaryTrack: false,
              trackOrientation: "",
              showDirection: false,
              group: "",
              railOptions: [],
            },
            startMarker: "",
            endMarker: "",
            testForm: [
              {
                startDate: "2023-07-01T04:00:00.000Z",
                assetType: "Storage Track 1",
                testCode: "sidingInspectionForm1",
                assetId: "6213c3b36bf5782270508b16",
                nextDueDate: "2023-10-01T04:00:00.000Z",
                nextExpiryDate: "2023-11-01T03:59:59.000Z",
                testId: "b839730a-e0f1-0a00-ca0e-241e20096a11",
                start: 0,
                end: 0,
                lineId: "",
                title: "Monthly Storage Track Inspection",
                timezone: "",
                currentPeriodStart: "2023-10-01T04:00:00.000Z",
                currentPeriodEnd: "2023-11-01T03:59:59.000Z",
                linearProps: {
                  inspectionType: "traversed",
                },
                alertInfo: {
                  expiryAlertDays: "5",
                },
              },
            ],
            freeze: false,
            appForms: [],
            formLists: {
              appFormsList: ["sidingInspectionForm1"],
            },
          },
          {
            track_id: "null",
            id: "6213c3b36bf5782270508b1e",
            unitId: "FERONIA SOUTH SWITCH",
            start: "8.8",
            end: "8.8",
            assetType: "Switch",
            coordinates: [
              ["46.36135541255538", "-79.32483628644022"],
              ["46.36135541255538", "-79.32483628644022"],
            ],
            parent_id: "6213bd64cb915c1c14002fcc",
            attributes: {
              primaryTrack: false,
              trackOrientation: "",
              showDirection: false,
              group: "",
              railOptions: [],
            },
            startMarker: "",
            endMarker: "",
            testForm: [
              {
                startDate: "2022-07-01T04:00:00.000Z",
                assetType: "Switch",
                testCode: "monthlydetailedformONR",
                assetId: "6213c3b36bf5782270508b1e",
                nextDueDate: "2023-10-01T04:00:00.000Z",
                nextExpiryDate: "2023-11-01T03:59:59.000Z",
                testId: "4a352246-eb47-d1ab-bd5d-3f7b758741e8",
                start: 0,
                end: 0,
                lineId: "",
                title: "Monthly Mainline Turnout Inspection",
                timezone: "",
                currentPeriodStart: "2023-10-01T04:00:00.000Z",
                currentPeriodEnd: "2023-11-01T03:59:59.000Z",
                linearProps: {
                  inspectionType: "",
                },
                alertInfo: {
                  expiryAlertDays: "5",
                },
              },
              {
                startDate: "2022-01-01T05:00:00.000Z",
                assetType: "Switch",
                testCode: "onrTurnoutForm",
                assetId: "6213c3b36bf5782270508b1e",
                nextDueDate: "2024-01-01T05:00:00.000Z",
                nextExpiryDate: "2024-08-15T03:59:59.000Z",
                testId: "458b0a75-7dfb-c429-7ca2-6a563f679149",
                start: 0,
                end: 0,
                lineId: "",
                title: "Annual Detailed Turnout Inspection ",
                timezone: "",
                currentPeriodStart: "2023-01-01T05:00:00.000Z",
                currentPeriodEnd: "2024-01-01T04:59:59.000Z",
                linearProps: {
                  inspectionType: "",
                },
                alertInfo: {
                  expiryAlertDays: "14",
                },
              },
            ],
            freeze: false,
            appForms: [],
            formLists: {
              appFormsList: ["onrTurnoutForm", "monthlydetailedformONR"],
            },
            adjCoordinates: {
              type: "Point",
              coordinates: [-79.32539250701666, 46.36090258214412],
            },
          },
          {
            track_id: "null",
            id: "6213c3b36bf5782270508b1f",
            unitId: "FERONIA NORTH SWITCH",
            start: "9.56",
            end: "9.56",
            assetType: "Switch",
            coordinates: [
              ["46.368685977632566", "-79.31298326991147"],
              ["46.368685977632566", "-79.31298326991147"],
            ],
            parent_id: "6213bd64cb915c1c14002fcc",
            attributes: {
              primaryTrack: false,
              trackOrientation: "",
              showDirection: false,
              group: "",
              railOptions: [],
            },
            startMarker: "",
            endMarker: "",
            testForm: [
              {
                startDate: "2022-07-01T04:00:00.000Z",
                assetType: "Switch",
                testCode: "monthlydetailedformONR",
                assetId: "6213c3b36bf5782270508b1f",
                nextDueDate: "2023-10-01T04:00:00.000Z",
                nextExpiryDate: "2023-11-01T03:59:59.000Z",
                testId: "4a352246-eb47-d1ab-bd5d-3f7b758741e8",
                start: 0,
                end: 0,
                lineId: "",
                title: "Monthly Mainline Turnout Inspection",
                timezone: "",
                currentPeriodStart: "2023-10-01T04:00:00.000Z",
                currentPeriodEnd: "2023-11-01T03:59:59.000Z",
                linearProps: {
                  inspectionType: "",
                },
                alertInfo: {
                  expiryAlertDays: "5",
                },
              },
              {
                startDate: "2022-01-01T05:00:00.000Z",
                assetType: "Switch",
                testCode: "onrTurnoutForm",
                assetId: "6213c3b36bf5782270508b1f",
                nextDueDate: "2024-01-01T05:00:00.000Z",
                nextExpiryDate: "2024-08-22T03:59:59.000Z",
                testId: "458b0a75-7dfb-c429-7ca2-6a563f679149",
                start: 0,
                end: 0,
                lineId: "",
                title: "Annual Detailed Turnout Inspection ",
                timezone: "",
                currentPeriodStart: "2023-01-01T05:00:00.000Z",
                currentPeriodEnd: "2024-01-01T04:59:59.000Z",
                linearProps: {
                  inspectionType: "",
                },
                alertInfo: {
                  expiryAlertDays: "14",
                },
              },
            ],
            freeze: false,
            appForms: [],
            formLists: {
              appFormsList: ["onrTurnoutForm", "monthlydetailedformONR"],
            },
          },
          {
            track_id: "null",
            id: "6213c3b36bf5782270508b20",
            unitId: "MULOCK SPUR SWITCH",
            start: "18.92",
            end: "18.92",
            assetType: "Switch",
            coordinates: [
              ["46.46270524965676", "-79.38311637068384"],
              ["46.46270524965676", "-79.38311637068384"],
            ],
            parent_id: "6213bd64cb915c1c14002fcc",
            attributes: {
              primaryTrack: false,
              trackOrientation: "",
              showDirection: false,
              group: "",
              railOptions: [],
            },
            startMarker: "",
            endMarker: "",
            testForm: [
              {
                startDate: "2022-07-01T04:00:00.000Z",
                assetType: "Switch",
                testCode: "monthlydetailedformONR",
                assetId: "6213c3b36bf5782270508b20",
                nextDueDate: "2023-10-01T04:00:00.000Z",
                nextExpiryDate: "2023-10-13T03:59:59.000Z",
                testId: "4a352246-eb47-d1ab-bd5d-3f7b758741e8",
                start: 0,
                end: 0,
                lineId: "",
                title: "Monthly Mainline Turnout Inspection",
                timezone: "",
                currentPeriodStart: "2023-10-01T04:00:00.000Z",
                currentPeriodEnd: "2023-11-01T03:59:59.000Z",
                linearProps: {
                  inspectionType: "",
                },
                alertInfo: {
                  expiryAlertDays: "5",
                },
              },
              {
                startDate: "2022-01-01T05:00:00.000Z",
                assetType: "Switch",
                testCode: "onrTurnoutForm",
                assetId: "6213c3b36bf5782270508b20",
                nextDueDate: "2023-01-01T05:00:00.000Z",
                nextExpiryDate: "2024-01-01T04:59:59.000Z",
                testId: "458b0a75-7dfb-c429-7ca2-6a563f679149",
                start: 0,
                end: 0,
                lineId: "",
                title: "Annual Detailed Turnout Inspection ",
                timezone: "",
                currentPeriodStart: "2023-01-01T05:00:00.000Z",
                currentPeriodEnd: "2024-01-01T04:59:59.000Z",
                linearProps: {
                  inspectionType: "",
                },
                alertInfo: {
                  expiryAlertDays: "14",
                },
              },
            ],
            freeze: false,
            appForms: [],
            formLists: {
              appFormsList: ["onrTurnoutForm", "monthlydetailedformONR"],
            },
          },
          {
            track_id: "null",
            id: "6213c3b46bf5782270508b3c",
            unitId: "FERONIA BACK TRACK SOUTH SWITCH",
            start: "8.9",
            end: "8.9",
            assetType: "Switch",
            coordinates: [
              ["46.362378831462124", "-79.32335332345646"],
              ["46.362378831462124", "-79.32335332345646"],
            ],
            parent_id: "6213bd64cb915c1c14002fcc",
            attributes: {
              primaryTrack: false,
              trackOrientation: "",
              showDirection: false,
              group: "",
              railOptions: [],
            },
            startMarker: "",
            endMarker: "",
            testForm: [
              {
                startDate: "2022-07-01T04:00:00.000Z",
                assetType: "Switch",
                testCode: "monthlydetailedformONR",
                assetId: "6213c3b46bf5782270508b3c",
                nextDueDate: "2023-10-01T04:00:00.000Z",
                nextExpiryDate: "2023-11-01T03:59:59.000Z",
                testId: "4a352246-eb47-d1ab-bd5d-3f7b758741e8",
                start: 0,
                end: 0,
                lineId: "",
                title: "Monthly Mainline Turnout Inspection",
                timezone: "",
                currentPeriodStart: "2023-10-01T04:00:00.000Z",
                currentPeriodEnd: "2023-11-01T03:59:59.000Z",
                linearProps: {
                  inspectionType: "",
                },
                alertInfo: {
                  expiryAlertDays: "5",
                },
              },
              {
                startDate: "2022-01-01T05:00:00.000Z",
                assetType: "Switch",
                testCode: "onrTurnoutForm",
                assetId: "6213c3b46bf5782270508b3c",
                nextDueDate: "2023-01-01T05:00:00.000Z",
                nextExpiryDate: "2024-01-01T04:59:59.000Z",
                testId: "458b0a75-7dfb-c429-7ca2-6a563f679149",
                start: 0,
                end: 0,
                lineId: "",
                title: "Annual Detailed Turnout Inspection ",
                timezone: "",
                currentPeriodStart: "2023-01-01T05:00:00.000Z",
                currentPeriodEnd: "2024-01-01T04:59:59.000Z",
                linearProps: {
                  inspectionType: "",
                },
                alertInfo: {
                  expiryAlertDays: "14",
                },
              },
            ],
            freeze: false,
            appForms: [],
            formLists: {
              appFormsList: ["onrTurnoutForm", "monthlydetailedformONR"],
            },
          },
          {
            track_id: "null",
            id: "6213c3b46bf5782270508b3d",
            unitId: "FERONIA BACK TRACK NORTH SWITCH",
            start: "9",
            end: "9",
            assetType: "Switch",
            coordinates: [
              ["46.36340223119841", "-79.32187030491347"],
              ["46.36340223119841", "-79.32187030491347"],
            ],
            parent_id: "6213bd64cb915c1c14002fcc",
            attributes: {
              primaryTrack: false,
              trackOrientation: "",
              showDirection: false,
              group: "",
              railOptions: [],
            },
            startMarker: "",
            endMarker: "",
            testForm: [
              {
                startDate: "2022-07-01T04:00:00.000Z",
                assetType: "Switch",
                testCode: "monthlydetailedformONR",
                assetId: "6213c3b46bf5782270508b3d",
                nextDueDate: "2023-10-01T04:00:00.000Z",
                nextExpiryDate: "2023-11-01T03:59:59.000Z",
                testId: "4a352246-eb47-d1ab-bd5d-3f7b758741e8",
                start: 0,
                end: 0,
                lineId: "",
                title: "Monthly Mainline Turnout Inspection",
                timezone: "",
                currentPeriodStart: "2023-10-01T04:00:00.000Z",
                currentPeriodEnd: "2023-11-01T03:59:59.000Z",
                linearProps: {
                  inspectionType: "",
                },
                alertInfo: {
                  expiryAlertDays: "5",
                },
              },
              {
                startDate: "2022-01-01T05:00:00.000Z",
                assetType: "Switch",
                testCode: "onrTurnoutForm",
                assetId: "6213c3b46bf5782270508b3d",
                nextDueDate: "2023-01-01T05:00:00.000Z",
                nextExpiryDate: "2024-01-01T04:59:59.000Z",
                testId: "458b0a75-7dfb-c429-7ca2-6a563f679149",
                start: 0,
                end: 0,
                lineId: "",
                title: "Annual Detailed Turnout Inspection ",
                timezone: "",
                currentPeriodStart: "2023-01-01T05:00:00.000Z",
                currentPeriodEnd: "2024-01-01T04:59:59.000Z",
                linearProps: {
                  inspectionType: "",
                },
                alertInfo: {
                  expiryAlertDays: "14",
                },
              },
            ],
            freeze: false,
            appForms: [],
            formLists: {
              appFormsList: ["onrTurnoutForm", "monthlydetailedformONR"],
            },
          },
          {
            track_id: "null",
            id: "631f875a0fb67e3a5139312f",
            unitId: "TEMAGAMI MAINLINE (MP 0 - MP 25.1)",
            start: "0",
            end: "25.1",
            assetType: "track",
            coordinates: [
              ["46.29496459648388", "-79.44794297218323"],
              ["46.538312516791684", "-79.42784662765382"],
            ],
            parent_id: "6213bd64cb915c1c14002fcc",
            attributes: {
              primaryTrack: true,
              trackOrientation: "",
              showDirection: true,
              group: "",
              railOrientation: "EW",
              railOptions: ["N/A", "East", "West"],
            },
            startMarker: "",
            endMarker: "",
            testForm: [
              {
                startDate: "2022-01-02T05:00:00.000Z",
                assetType: "track",
                testCode: "inspectionForm1",
                assetId: "631f875a0fb67e3a5139312f",
                nextDueDate: "2023-10-01T04:00:00.000Z",
                nextExpiryDate: "2023-10-08T03:59:59.000Z",
                testId: "4337aecd-bb40-9d63-0987-a0fa4c49c3ee",
                start: 0,
                end: 0,
                lineId: "",
                title: "Main Track Inspection - Weekly ",
                timezone: "",
                currentPeriodStart: "2023-10-01T05:00:00.000Z",
                currentPeriodEnd: "2023-10-08T03:59:59.000Z",
                linearProps: {
                  inspectionType: "traversed",
                },
                alertInfo: {
                  expiryAlertDays: "1",
                },
              },
            ],
            freeze: true,
            appForms: [
              {
                id: "inspectionForm1",
                name: "Inspection Form 1",
                form: [
                  {
                    id: "Inspected",
                    name: "Scheduled Inspection",
                    tag: "completionCheck",
                    value: "true",
                    type: "checkbox",
                  },
                ],
              },
              {},
            ],
            formLists: {
              appFormsList: ["inspectionForm1", "inspectionForm3"],
            },
          },
          {
            track_id: "null",
            id: "63d7ec586a6b31041ae5b117",
            unitId: "PICHES SPUR SWITCH",
            start: "0.72",
            end: "0.72",
            assetType: "Switch",
            coordinates: [
              ["46.30390466681828", "-79.44858807141375"],
              ["46.30390466681828", "-79.44858807141375"],
            ],
            parent_id: "6213bd64cb915c1c14002fcc",
            attributes: {
              primaryTrack: false,
              trackOrientation: "",
              showDirection: false,
              group: "",
              railOptions: [],
            },
            startMarker: "",
            endMarker: "",
            testForm: [
              {
                startDate: "2022-07-01T04:00:00.000Z",
                assetType: "Switch",
                testCode: "monthlydetailedformONR",
                assetId: "63d7ec586a6b31041ae5b117",
                nextDueDate: "2023-10-01T04:00:00.000Z",
                nextExpiryDate: "2023-11-01T03:59:59.000Z",
                testId: "4a352246-eb47-d1ab-bd5d-3f7b758741e8",
                start: 0,
                end: 0,
                lineId: "",
                title: "Monthly Mainline Turnout Inspection",
                timezone: "",
                currentPeriodStart: "2023-10-01T04:00:00.000Z",
                currentPeriodEnd: "2023-11-01T03:59:59.000Z",
                linearProps: {
                  inspectionType: "",
                },
                alertInfo: {
                  expiryAlertDays: "5",
                },
              },
              {
                startDate: "2022-01-01T05:00:00.000Z",
                assetType: "Switch",
                testCode: "onrTurnoutForm",
                assetId: "63d7ec586a6b31041ae5b117",
                nextDueDate: "2024-01-01T05:00:00.000Z",
                nextExpiryDate: "2024-08-19T03:59:59.000Z",
                testId: "458b0a75-7dfb-c429-7ca2-6a563f679149",
                start: 0,
                end: 0,
                lineId: "",
                title: "Annual Detailed Turnout Inspection ",
                timezone: "",
                currentPeriodStart: "2023-01-01T05:00:00.000Z",
                currentPeriodEnd: "2024-01-01T04:59:59.000Z",
                linearProps: {
                  inspectionType: "",
                },
                alertInfo: {
                  expiryAlertDays: "14",
                },
              },
            ],
            freeze: false,
            appForms: [],
            formLists: {
              appFormsList: ["onrTurnoutForm", "monthlydetailedformONR"],
            },
          },
        ],
        isYardInspection: false,
        runRanges: [],
      },
    ],
    jobBriefings: [],
    intervals: [
      {
        id: "47d201b5-94cb-4c81-8882-ee5242a17bb6",
        start: "0",
        end: "25.1",
        status: "closed",
        expEnd: "25.1",
        startTime: "Fri Oct 06 23:04:05 EDT 2023",
        startLocation: "46.41446893,-79.21141833",
        traversed: "631f875a0fb67e3a5139312f",
        observed: "",
        allSideTracks: false,
        endTime: "Fri Oct 06 23:04:20 EDT 2023",
        endLocation: "46.41446834,-79.21144528",
      },
    ],
    events: [],  
    date: "2023-10-07T03:04:05.000Z",
    title: "Temagami Territory 1 Main Track Inspection",
    workplanTemplateId: "64501d8136d549e323dece35",
    state: "",
    lineId: "6213bd64cb915c1c14002fcc",
    lineName: "",
    startDateTime: "Fri Oct 06 23:04:05 EDT 2023",
    startLocation: "46.41446893,-79.21141833",
    endDateTime: "Fri Oct 06 23:04:20 EDT 2023",
    endLocation: "46.41446834,-79.21144528",
    status: "Finished",
    subdivision: "",
    privateKey: "L-e198f9ef-2b2b-4286-90bb-eb018b7f506f",
    planType: "",
    createdAt: "2023-10-07T03:04:08.539Z",
    updatedAt: "2023-10-07T03:04:23.241Z",
    __v: 0,
    inspectionCompleted: true,
  }




// WEBPACK FOOTER //
// ./src/components/Simulator/data.js